const { IS_DEV } = require('../constants/AppConstants');
const DepositZapMetaCryptoAbi = require('../constants/abis/json/factory-crypto/DepositZapMetaCrypto.json');
const DepositZapMetaBtcPolygonAbi = require('../constants/abis/json/factory-v2/DepositZapMetaBtcPolygon.json');
const DepositZapMetaUsdPolygonAbi = require('../constants/abis/json/factory-v2/DepositZapMetaUsdPolygon.json');
const DepositZapMetaUsd2Fantom = require('../constants/abis/json/factory-v2/DepositZapMetaUsd2Fantom.json');
const DepositZapMetaUsd2Ethereum = require('../constants/abis/json/factory-v2/DepositZapMetaUsd2Ethereum.json');
const DepositZapMetaBtc3Ethereum = require('../constants/abis/json/factory-v2/DepositZapMetaBtc3Ethereum.json');
const DepositZapMetaUsd2OptimismAbi = require('../constants/abis/json/factory-v2/DepositZapMetaUsd2OptimismAbi.json');
const DepositZapMetaCryptoFraxbpAbi = require('../constants/abis/json/factory-crypto/DepositZapMetaCryptoFraxbpAbi.json');
const DepositZapMetaCrypto3poolAbi = require('../constants/abis/json/factory-crypto/DepositZapMetaCrypto3poolAbi.json');

// const BASE_API_DOMAIN = IS_DEV ? 'http://localhost:3000' : 'https://api.curve.finance';
const BASE_API_DOMAIN = 'https://api.curve.finance';

const configs = {
    ethereum: {
        name: 'Ethereum',
        blockchainId: 'ethereum',
        coingeckoAssetId: 'ethereum',
        coingeckoPlatformId: 'ethereum',
        nativeAssetId: 'eth', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'weth', // Used by crypto facto, since it handles wrapped native as native
        networkId: 1,
        blocknativeSupport: true,
        nativeCurrency: {
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.mevblocker.io/fast',
        blocknativeUnlockedRpcUrl: 'https://eth.drpc.org',
        rawStatsPath: 'raw-stats',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://etherscan.io/',
            address: 'https://etherscan.io/address/',
            token: 'https://etherscan.io/token/',
            tx: 'https://etherscan.io/tx/',
        },
        walletGuideUrl: null,
        display: {
            txCostPrecision: 2,
        },
        cryptoPoolsThatNeedSpecialRateCalculationWhenRamping: ['tricrypto2'],
        totalVolumeApiEndpoint: `${BASE_API_DOMAIN}/api/getAllPoolsVolume/ethereum`,
        factoryRegistryAddress: '0x0959158b6040D32d04c301A72CBFD6b39E21c9AE',
        factoryV2RegistryAddress: '0xb9fc157394af804a3578134a6585c0dc9cc990d4',
        factoryV2PlainPeggedProxyAddress: '0x742c3cf9af45f91b109a81efeaf11535ecde9571',
        factoryV2GaugeManagerExtensionAddress: '0x201798B679859DDF129651d6B58a5C32527EA04c',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs?version=2`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/ethereum/main`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/ethereum/crypto`,
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/ethereum/factory`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getAllGauges`,
        factoryV2MetaUsdBasePoolId: '3pool',
        factoryV2MetaUsd2BasePoolId: 'fraxusdc',
        factoryV2MetaUsd2BasePoolName: 'fraxbp',
        factoryV2MetaBtcBasePoolId: 'sbtc',
        factoryV2MetaBtc2BasePoolId: 'ren',
        factoryV2MetaBtc3BasePoolId: 'sbtc2',
        factoryV2MetaUsdDepositZapAddress: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
        factoryV2MetaUsd2DepositZapAddress: '0x08780fb7E580e492c1935bEe4fA5920b94AA95Da',
        factoryV2MetaUsd2DepositZapAbi: DepositZapMetaUsd2Ethereum,
        factoryV2MetaBtcDepositZapAddress: '0x7abdbaf29929e7f8621b757d2a7c04d78d633834',
        factoryV2MetaBtc3DepositZapAbi: DepositZapMetaBtc3Ethereum,
        factoryV2MetaBtc3DepositZapAddress: '0xA2d40Edbf76C6C0701BA8899e2d059798eBa628e',
        factoryV2AllowsAllPlainPools: false,
        factoryV2CanCreateGauges: true,
        factoryCryptoRegistryAddress: '0xF18056Bbd320E96A48e3Fbf8bC061322531aac99',
        factoryCryptoGaugeManagerExtensionAddress: '0x9f99FDe2ED3997EAfE52b78E3981b349fD2Eb8C9',
        factoryCryptoApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs?version=crypto`,
        factoryCryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/ethereum/factory-crypto`,
        factoryCryptoMetaBasePoolId: 'fraxusdc',
        factoryCryptoMetaBasePoolName: 'fraxbp',
        factoryCryptoMetaDepositZapAddress: '0x5de4ef4879f4fe3bbadf2227d2ac5d0e2d76c895',
        factoryCryptoMetaDepositZapAbi: DepositZapMetaCryptoFraxbpAbi,
        factoryCryptoMeta2BasePoolId: '3pool',
        factoryCryptoMeta2BasePoolName: '3pool',
        factoryCryptoMeta2DepositZapAddress: '0x97aDC08FA1D849D2C48C5dcC1DaB568B169b0267',
        factoryCryptoMeta2DepositZapAbi: DepositZapMetaCrypto3poolAbi,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/ethereum',
        multicall2Address: '0x5ba1e12693dc8f9c48aad8770482f4739beed696',
    },
    fantom: {
        name: 'Fantom',
        blockchainId: 'fantom',
        coingeckoAssetId: 'fantom',
        coingeckoPlatformId: 'fantom',
        nativeAssetId: 'ftm', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wftm',
        networkId: 250,
        blocknativeSupport: true,
        nativeCurrency: {
            symbol: 'FTM',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.ftm.tools/',
        rawStatsPath: 'raw-stats-ftm',
        logoPath: 'logos/logo_optimized-ftm.svg',
        explorerBaseUrl: {
            root: 'https://ftmscan.com/',
            address: 'https://ftmscan.com/address/',
            token: 'https://ftmscan.com/token/',
            tx: 'https://ftmscan.com/tx/',
        },
        walletGuideUrl: 'https://resources.curve.finance/guides/using-curve-on-fantom',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: `${BASE_API_DOMAIN}/api/getAllPoolsVolume/fantom`,
        factoryV2RegistryAddress: '0x686d67265703d1f124c45e33d47d794c566889ba',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-fantom`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/fantom/main`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/fantom/crypto`,
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/fantom`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/fantom/factory`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/fantom`,
        factoryV2MetaUsdBasePoolId: '2pool',
        factoryV2MetaBtcBasePoolId: 'ren',
        factoryV2MetaUsd2BasePoolId: 'geist',
        factoryV2MetaUsdDepositZapAddress: '0x78D51EB71a62c081550EfcC0a9F9Ea94B2Ef081c',
        factoryV2MetaUsd2DepositZapAddress: '0x247aEB220E87f24c40C9F86b65d6bd5d3c987B55',
        factoryV2MetaUsd2DepositZapAbi: DepositZapMetaUsd2Fantom, // Need to specify abi because two levels deep so specific handling
        factoryV2MetaBtcDepositZapAddress: '0x001E3BA199B4FF4B5B6e97aCD96daFC0E2e4156e',
        factoryV2AllowsAllPlainPools: true, // This factory allows overlap b/w plain pools assets and base pools assets
        factoryV2CanCreateGauges: false,
        factoryCryptoRegistryAddress: '0xE5De15A9C9bBedb4F5EC13B131E61245f2983A69',
        factoryCryptoApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-fantom?version=crypto`,
        factoryCryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/fantom/factory-crypto`,
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/fantom',
        multicall2Address: '0xD98e3dBE5950Ca8Ce5a4b59630a5652110403E5c',
    },
    bsc: {
        name: 'Binance Smart Chain',
        blockchainId: 'bsc',
        coingeckoAssetId: 'bsc',
        coingeckoPlatformId: 'binance-smart-chain',
        nativeAssetId: 'bnb', // Coin id from the blockchain's coins config
        networkId: 56,
        nativeCurrency: {
            symbol: 'BNB',
            decimals: 18,
        },
        rpcUrl: 'https://bsc-dataseed.binance.org/',
        rawStatsPath: 'raw-stats-bsc',
        logoPath: 'logos/logo_optimized-ftm.svg',
        explorerBaseUrl: {
            root: 'https://bscscan.com/',
            address: 'https://bscscan.com/address/',
            tx: 'https://bscscan.com/tx/',
        },
        walletGuideUrl: 'https://resources.curve.finance/guides/using-curve-on-fantom',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
    },
    polygon: {
        name: 'Polygon',
        blockchainId: 'polygon',
        coingeckoAssetId: 'matic-network',
        coingeckoPlatformId: 'polygon-pos',
        nativeAssetId: 'matic', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wmatic',
        networkId: 137,
        blocknativeSupport: true, //should be true
        nativeCurrency: {
            symbol: 'MATIC',
            decimals: 18,
        },
        rpcUrl: 'https://polygon.drpc.org',
        rawStatsPath: 'raw-stats-polygon',
        logoPath: 'logos/logo_optimized-polygon.svg',
        explorerBaseUrl: {
            root: 'https://polygonscan.com/',
            address: 'https://polygonscan.com/address/',
            tx: 'https://polygonscan.com/tx/',
            token: 'https://polygonscan.com/token/',
        },
        walletGuideUrl: 'https://blog.matic.network/deposits-and-withdrawals-on-matic-network-walkthrough-guide/',
        display: {
            txCostPrecision: 5,
        },
        cryptoPoolsThatNeedSpecialRateCalculationWhenRamping: ['atricrypto3'],
        totalVolumeApiEndpoint: `${BASE_API_DOMAIN}/api/getAllPoolsVolume/polygon`,
        factoryV2RegistryAddress: '0x722272d36ef0da72ff51c5a65db7b870e2e8d4ee',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-polygon`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/polygon/main`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/polygon/crypto`,
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/polygon`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/polygon/factory`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/polygon`,
        factoryV2MetaUsdBasePoolId: 'aave',
        factoryV2MetaBtcBasePoolId: 'ren',
        factoryV2MetaUsdDepositZapAddress: '0x5ab5C56B9db92Ba45a0B46a207286cD83C15C939',
        factoryV2MetaBtcDepositZapAddress: '0xE2e6DC1708337A6e59f227921db08F21e3394723',
        factoryV2MetaUsdDepositZapAbi: DepositZapMetaUsdPolygonAbi,
        factoryV2MetaBtcDepositZapAbi: DepositZapMetaBtcPolygonAbi,
        factoryV2AllowsAllPlainPools: true, // This factory allows overlap b/w plain pools assets and base pools assets
        factoryV2CanCreateGauges: false,
        factoryCryptoRegistryAddress: '0xE5De15A9C9bBedb4F5EC13B131E61245f2983A69',
        factoryCryptoApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-polygon?version=crypto`,
        factoryCryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/polygon/factory-crypto`,
        factoryCryptoMetaBasePoolId: 'atricrypto3',
        factoryCryptoMetaDepositZapAddress: '0x3d8EADb739D1Ef95dd53D718e4810721837c69c1',
        factoryCryptoMetaDepositZapAbi: DepositZapMetaCryptoAbi,
        multicall2Address: '0x275617327c958bD06b5D6b871E7f491D76113dd8',
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/polygon',
    },
    xdai: {
        name: 'xDai',
        blockchainId: 'xdai',
        coingeckoAssetId: 'xdai-stake',
        coingeckoPlatformId: 'xdai',
        nativeAssetId: 'xdai', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wxdai',
        networkId: 100,
        blocknativeSupport: true,
        nativeCurrency: {
            symbol: 'xDai',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.gnosischain.com/',
        rawStatsPath: 'raw-stats-xdai',
        logoPath: 'logos/logo_optimized-xdai.svg',
        explorerBaseUrl: {
            root: 'https://gnosisscan.io/',
            address: 'https://gnosisscan.io/address/',
            tx: 'https://gnosisscan.io/tx/',
        },
        walletGuideUrl: 'https://www.xdaichain.com/for-users/wallets/metamask/metamask-setup',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: `${BASE_API_DOMAIN}/api/getAllPoolsVolume/xdai`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/xdai/main`,
        factoryV2RegistryAddress: '0xD19Baeadc667Cf2015e395f2B08668Ef120f41F5',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-xdai`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/xdai/crypto`,
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/xdai`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/xdai/factory`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/xdai`,
        factoryV2MetaUsdBasePoolId: '3pool',
        factoryV2MetaUsdDepositZapAddress: '0x87C067fAc25f123554a0E76596BF28cFa37fD5E9',
        factoryV2AllowsAllPlainPools: true, // This factory allows overlap b/w plain pools assets and base pools assets
        factoryV2CanCreateGauges: false,
        multicall2Address: '0xFAa296891cA6CECAF2D86eF5F7590316d0A17dA0',
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/xdai',
    },
    arbitrum: {
        name: 'Arbitrum',
        blockchainId: 'arbitrum',
        coingeckoAssetId: 'ethereum',
        coingeckoPlatformId: 'arbitrum-one',
        nativeAssetId: 'eth', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'weth',
        networkId: 42161,
        blocknativeSupport: true,
        nativeCurrency: {
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrl: 'https://arbitrum.drpc.org',
        publicRpcUrl: 'https://arbitrum.drpc.org',
        rawStatsPath: 'raw-stats-arbitrum',
        logoPath: 'logos/logo_optimized-arbitrum.svg',
        explorerBaseUrl: {
            root: 'https://arbiscan.io/',
            address: 'https://arbiscan.io/address/',
            tx: 'https://arbiscan.io/tx/',
            token: 'https://arbiscan.io/token/',
        },
        walletGuideUrl: 'https://medium.com/stakingbits/guide-to-arbitrum-and-setting-up-metamask-for-arbitrum-543e513cdd8b',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: `${BASE_API_DOMAIN}/api/getAllPoolsVolume/arbitrum`,
        factoryV2RegistryAddress: '0xb17b674D9c5CB2e441F8e196a2f048A81355d031',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-arbitrum`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/arbitrum/main`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/arbitrum/crypto`,
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/arbitrum`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/arbitrum/factory`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/arbitrum`,
        factoryV2MetaUsdBasePoolId: '2pool',
        factoryV2MetaUsd2BasePoolId: 'factory-v2-41', // fraxbp
        factoryV2MetaUsd2BasePoolName: 'fraxbp',
        factoryV2MetaBtcBasePoolId: 'ren',
        factoryV2MetaUsdDepositZapAddress: '0x7544Fe3d184b6B55D6B36c3FCA1157eE0Ba30287',
        factoryV2MetaUsd2DepositZapAddress: '0x58AC91f5BE7dC0c35b24B96B19BAc55FBB8E705e',
        factoryV2MetaBtcDepositZapAddress: '0x803A2B40c5a9BB2B86DD630B274Fa2A9202874C2',
        factoryV2AllowsAllPlainPools: true, // This factory allows overlap b/w plain pools assets and base pools assets
        factoryV2CanCreateGauges: false,
        multicall2Address: '0x5b5cfe992adac0c9d48e05854b2d91c73a003858',
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/arbitrum',
    },
    avalanche: {
        name: 'Avalanche',
        blockchainId: 'avalanche',
        coingeckoAssetId: 'avalanche-2',
        coingeckoPlatformId: 'avalanche',
        nativeAssetId: 'avax', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wavax',
        networkId: 43114,
        blocknativeSupport: true,
        nativeCurrency: {
            symbol: 'AVAX',
            decimals: 18,
        },
        rpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
        publicRpcUrl: 'https://api.avax.network/ext/bc/C/rpc',
        rawStatsPath: 'raw-stats-avalanche',
        logoPath: 'logos/logo_optimized-avalanche.svg',
        explorerBaseUrl: {
            root: 'https://snowtrace.io/',
            address: 'https://snowtrace.io/address/',
            tx: 'https://snowtrace.io/tx/',
            token: 'https://snowtrace.io/token/',
        },
        walletGuideUrl: 'https://support.avax.network/en/articles/4626956-how-do-i-set-up-metamask-on-avalanche',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: `${BASE_API_DOMAIN}/api/getAllPoolsVolume/avalanche`,
        factoryV2RegistryAddress: '0xb17b674D9c5CB2e441F8e196a2f048A81355d031',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-avalanche`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/avalanche/main`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/avalanche/crypto`,
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/avalanche`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/avalanche/factory`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/avalanche`,
        factoryV2MetaUsdBasePoolId: 'aave',
        factoryV2MetaUsdDepositZapAddress: '0x001E3BA199B4FF4B5B6e97aCD96daFC0E2e4156e',
        factoryV2MetaUsdDepositZapAbi: DepositZapMetaUsdPolygonAbi,
        factoryV2AllowsAllPlainPools: false, // This factory allows overlap b/w plain pools assets and base pools assets
        factoryV2CanCreateGauges: false,
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/avalanche',
        multicall2Address: '0x29b6603D17B9D8f021EcB8845B6FD06E1Adf89DE',
    },
    harmony: {
        name: 'Harmony',
        blockchainId: 'harmony',
        coingeckoAssetId: 'harmony',
        coingeckoPlatformId: 'harmony-shard-0',
        nativeAssetId: 'one', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wone',
        blocknativeSupport: true,
        networkId: 1666600000,
        nativeCurrency: {
            symbol: 'ONE',
            decimals: 18,
        },
        rpcUrl: 'https://rpc.s0.t.hmny.io',
        publicRpcUrl: 'https://rpc.s0.t.hmny.io',
        rawStatsPath: 'raw-stats-harmony',
        logoPath: 'logos/logo_optimized-harmony.svg',
        explorerBaseUrl: {
            root: 'https://explorer.harmony.one/',
            address: 'https://explorer.harmony.one/address/',
            tx: 'https://explorer.harmony.one/tx/',
        },
        walletGuideUrl: 'https://docs.harmony.one/home/network/wallets/browser-extensions-wallets/metamask-wallet',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
        multicall2Address: '0x3E01dD8a5E1fb3481F0F589056b428Fc308AF0Fb',
    },
    optimism: {
        name: 'Optimism',
        blockchainId: 'optimism',
        coingeckoAssetId: 'ethereum',
        coingeckoPlatformId: 'optimistic-ethereum',
        nativeAssetId: 'eth', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'weth',
        blocknativeSupport: true,
        networkId: 10,
        nativeCurrency: {
            symbol: 'ETH',
            decimals: 18,
        },
        rpcUrl: 'https://optimism.drpc.org',
        publicRpcUrl: 'https://optimism.drpc.org',
        rawStatsPath: 'raw-stats-optimism',
        logoPath: 'logos/logo_optimized-optimism.svg',
        explorerBaseUrl: {
            root: 'https://optimistic.etherscan.io/',
            address: 'https://optimistic.etherscan.io/address/',
            tx: 'https://optimistic.etherscan.io/tx/',
            token: 'https://optimistic.etherscan.io/token/',
        },
        walletGuideUrl: 'https://metamask.zendesk.com/hc/en-us/articles/4403700785691-Using-Optimistic-Ethereum-with-MetaMask',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
        factoryV2RegistryAddress: '0x2db0E83599a91b508Ac268a6197b8B14F5e72840',
        subgraphStatsEndpoint: 'https://api.curve.finance/api/getSubgraphData/optimism',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-optimism`,
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/optimism/main`,
        cryptoPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/optimism/crypto`,
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getFactoryV2Pools-optimism`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/optimism`,
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/optimism`,
        factoryV2MetaUsdBasePoolId: '3pool',
        factoryV2MetaUsdDepositZapAddress: '0x167e42a1c7ab4be03764a2222aac57f5f6754411',
        factoryV2MetaUsdDepositZapAbi: DepositZapMetaUsdPolygonAbi,
        factoryV2MetaUsd2BasePoolId: 'factory-v2-16', // fraxbp
        factoryV2MetaUsd2BasePoolName: 'fraxbp',
        factoryV2MetaUsd2DepositZapAddress: '0x4244eB811D6e0Ef302326675207A95113dB4E1F8',
        factoryV2MetaUsd2DepositZapAbi: DepositZapMetaUsd2OptimismAbi,
        factoryV2AllowsAllPlainPools: false, // This factory allows overlap b/w plain pools assets and base pools assets
        factoryV2CanCreateGauges: false,
        multicall2Address: '0x2DC0E2aa608532Da689e89e237dF582B783E552C',
    },
    moonbeam: {
        name: 'Moonbeam',
        blockchainId: 'moonbeam',
        coingeckoAssetId: 'moonbeam',
        coingeckoPlatformId: 'moonbeam',
        nativeAssetId: 'GLMR', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wglmr',
        networkId: 1284,
        blocknativeSupport: false,
        nativeCurrency: {
            symbol: 'GLMR',
            decimals: 18,
        },
        rpcUrl: 'https://moonbeam.api.onfinality.io/public',
        rawStatsPath: 'raw-stats-moonbeam',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://moonscan.io/',
            address: 'https://moonscan.io/address/',
            tx: 'https://moonscan.io/tx/',
        },
        walletGuideUrl: 'https://docs.moonbeam.network/tokens/connect/metamask/',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
        apiEndpoint: 'Moonbeam',
        multicall2Address: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        factoryV2RegistryAddress: '0x4244eB811D6e0Ef302326675207A95113dB4E1F8',
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/moonbeam/main`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-moonbeam`,
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getFactoryV2Pools-moonbeam`,
        factoryV2AllowsAllPlainPools: true, // no meta pools atm so irrelevant, only for display purposes
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/moonbeam`,
        factoryV2CanCreateGauges: false,
    },
    aurora: {
        name: 'Aurora',
        blockchainId: 'aurora',
        coingeckoAssetId: 'aurora',
        coingeckoPlatformId: 'aurora',
        nativeAssetId: 'aETH', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'waETH',
        networkId: 1313161554,
        blocknativeSupport: false,
        nativeCurrency: {
            symbol: 'aETH',
            decimals: 18,
        },
        rpcUrl: 'https://mainnet.aurora.dev',
        rawStatsPath: 'raw-stats-aurora',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://aurorascan.dev/',
            address: 'https://aurorascan.dev/address/',
            tx: 'https://aurorascan.dev/tx/',
        },
        walletGuideUrl: 'https://doc.aurora.dev/interact/metamask/',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
        apiEndpoint: 'Aurora',
        multicall2Address: '0xace58a26b8Db90498eF0330fDC9C2655db0C45E2',
    },
    kava: {
        name: 'Kava',
        blockchainId: 'kava',
        coingeckoAssetId: 'kava',
        coingeckoPlatformId: 'kava',
        nativeAssetId: 'kava', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'wkava',
        networkId: 2222,
        rawStatsPath: 'raw-stats-kava',
        blocknativeSupport: false,
        nativeCurrency: {
            symbol: 'KAVA',
            decimals: 18,
        },
        rpcUrl: 'https://evm.kava.io',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://explorer.kava.io/',
            address: 'https://explorer.kava.io/address/',
            tx: 'https://explorer.kava.io/tx/',
        },
        walletGuideUrl: 'https://docs.kava.io/docs/ethereum/metamask/',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
        apiEndpoint: 'Kava',
        multicall2Address: '0x30A62aA52Fa099C4B227869EB6aeaDEda054d121',
        factoryV2RegistryAddress: '0x40bc62805471eF53DdD5C5cF99ed3d9e5aa81b48',
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/kava/main`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-kava`,
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getFactoryV2Pools-kava`,
        factoryV2AllowsAllPlainPools: true, // no meta pools atm so irrelevant, only for display purposes
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/kava`,
        factoryV2CanCreateGauges: false,
        hasNoMainPools: true,
    },
    celo: {
        name: 'Celo',
        blockchainId: 'celo',
        coingeckoAssetId: 'celo',
        coingeckoPlatformId: 'celo',
        nativeAssetId: 'celo', // Coin id from the blockchain's coins config
        nativeAssetErc20WrapperId: 'celo',
        networkId: 42220,
        rawStatsPath: 'raw-stats-celo',
        blocknativeSupport: false,
        nativeCurrency: {
            symbol: 'CELO',
            decimals: 18,
        },
        rpcUrl: 'https://forno.celo.org',
        logoPath: 'logos/logo_optimized.svg',
        explorerBaseUrl: {
            root: 'https://celoscan.io/',
            address: 'https://celoscan.io/address/',
            tx: 'https://celoscan.io/tx/',
        },
        walletGuideUrl: 'https://blog.polkastarter.com/how-to-add-celo-to-metamask/',
        display: {
            txCostPrecision: 5,
        },
        totalVolumeApiEndpoint: undefined,
        apiEndpoint: 'Celo',
        multicall2Address: '0xE72f42c64EA3dc05D2D94F541C3a806fa161c49B',
        factoryV2RegistryAddress: '0x5277A0226d10392295E8D383E9724D6E416d6e6C',
        mainPoolsEndpoint: `${BASE_API_DOMAIN}/api/getPools/celo/main`,
        sidechainFactoryRegistryAddress: '0xabC000d88f23Bb45525E447528DBF656A9D55bf5',
        factoryV2ApyEndpoint: `${BASE_API_DOMAIN}/api/getFactoryAPYs-celo`,
        factoryV2PoolsEndpoint: `${BASE_API_DOMAIN}/api/getFactoryV2Pools-celo`,
        factoryV2AllowsAllPlainPools: true, // no meta pools atm so irrelevant, only for display purposes
        factoSidechainGaugesCrvRewardsEndpoint: `${BASE_API_DOMAIN}/api/getFactoGaugesCrvRewards/celo`,
        factoryV2HasGauges: true,
        factoryV2GaugesEndpoint: `${BASE_API_DOMAIN}/api/getFactoGauges/celo`,
        factoryV2CanCreateGauges: false,
        hasNoMainPools: true,
    },
}

const getConfig = () => {
    const id = process.env.VUE_APP_BLOCKCHAIN_ID;
    const supportedIds = Array.from(Object.keys(configs));

    if (!supportedIds.includes(id)) {
        throw new Error(`Invalid env variable VUE_APP_BLOCKCHAIN_ID: "${id}"`);
    }

    return {
        ...configs[id],
        allConfigs: configs,
    };
};

module.exports = getConfig();
